import { StateCreator } from 'zustand'
import { IActiveOrgStore } from './interface'

// Persistence is handled by the persist middleware in store/index.tsx — the
// slice only holds state and setters.
export const createActiveOrgSlice: StateCreator<IActiveOrgStore> = (set) => ({
  activeOrgId: '',
  setActiveOrgId: (orgId) => set({ activeOrgId: orgId }),
  clearActiveOrg: () => set({ activeOrgId: '' }),
})
